import React from 'react';
import { AreaChart } from "@carbon/charts-react";
import ChartPanelWrapper from "../ChartPanelWrapper";
import { transformToKeyGroupValue, buildXYChartOptions, buildColorScale } from "../chartHelpers";

const Index = ({chart}) => {
    return (
        <ChartPanelWrapper chart={chart}>
            {(panelData) => {
                const data = transformToKeyGroupValue(panelData, chart);
                const colorScale = buildColorScale(data);
                const options = {
                    ...buildXYChartOptions(chart),
                    legend: { enabled: data.length > 0 },
                    color: { scale: colorScale }
                };
                return <AreaChart options={options} data={data} />;
            }}
        </ChartPanelWrapper>
    );
}

export default React.memo(Index)
